export const TIERS = {
    free: {
        name: 'Free',
        price: 0,
        maxGraphs: 3,
        maxNodesPerGraph: 10,
    },
    pro: {
        name: 'Pro',
        price: 9.99,
        maxGraphs: Infinity,
        maxNodesPerGraph: Infinity,
    },
};
//# sourceMappingURL=credit-tiers.js.map